/* eslint-disable import/prefer-default-export */

const isDevelopment = process.env.NODE_ENV !== 'production' || window.location.hostname.indexOf('localhost') !== -1;

export {
  isDevelopment,
};



// WEBPACK FOOTER //
// ./src/utils/environment.js